import React from 'react';
import classes from './ecosytemOpportunity.module.scss';

const SuggestionActionWarning = () => {
  return (
    <div className={classes['warning-banner']}>
      <div className='text text__normal text__black ms-4 me-4'>
        Select <strong>Product</strong>, <strong>Indication</strong>,{' '}
        <strong>Competitor Brand</strong>, <strong>Book of Business</strong>,
        and <strong>Benefit Type</strong> to display all elements in the visuals
        below and explore the desired ecosystem to see correlations.
      </div>
    </div>
  );
};

export default SuggestionActionWarning;
